<template>
  <div class="main-transfer">
    <el-row type="flex" class="row-bg" justify="space-around">
      <el-col :span="11">
        <transfer-list
          :list="leftList"
          :buttonName="buttonsNames[0]"
          :title="titlesNames[0]"
          @click="leftClick"
        ></transfer-list>
      </el-col>
      <el-col :span="11">
        <transfer-list
          :list="rightList"
          :buttonName="buttonsNames[1]"
          :title="titlesNames[1]"
          @click="rightClick"
        ></transfer-list>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import TransferList from "./TransferList";
export default {
  props: ["leftList", "rightList", "buttonsNames", "titlesNames"],
  methods: {
    leftClick(value) {
      this.$emit("leftListClick", value);
    },
    rightClick(value) {
      this.$emit("rightListClick", value);
    }
  },
  components: {
    TransferList
  }
};
</script>

<style scoped>
.el-col {
  margin-top: 10px;
}
.main-transfer{
  background: var(--main-background);
  padding-bottom: 39.2px;
}

</style>